import React from 'react';

const Achievements = () => {
  return (
    <section id="achievements">
      <div className="section-header animate-fade-in-up">
        <span className="section-number">04.</span>
        <h2 className="section-title">Achievements</h2>
        <div className="section-line"></div>
      </div>
      <div className="achievements-content">
        <div className="achievement animate-scale-in delay-2">
          <h3 className="animate-fade-in-up delay-3">Hack2Future Finalist – IIIT Dharwad</h3>
          <p className="animate-fade-in-up delay-3">Top 40/480+ teams</p>
        </div>
        <div className="achievement animate-scale-in delay-3">
          <h3 className="animate-fade-in-up delay-4">SuPrathon</h3>
          <p className="animate-fade-in-up delay-4">Top 20 teams across India (Multimodal AI interview analysis system)</p>
        </div>
      </div>
    </section>
  );
};

export default Achievements;